<template>
  <div>
    <Navbar :toReset="(url, stay, noTab) => this.reset(url, stay, noTab)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar
          active="UGD"
          :toReset="(url, stay, noTab) => this.reset(url, stay, noTab)"
        />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <div class="row mb-1">
            <div class="col-md-12">
              <h5 class="text-uppercase text-info mb-3">
                TRIASE DAN PENGKAJIAN AWAL
              </h5>
              <FormRow
                v-for="row in upperForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <hr />
          <div class="row mb-5">
            <div class="col-md-6">
              <FormRow
                v-for="row in formKeluhan"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <h5 class="mt-4 mb-3">TANDA VITAL</h5>
              <FormRow
                v-for="row in formVital"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <h5 class="mt-4 mb-3">STATUS ALERGI</h5>
              <FormRow
                v-for="row in formAlergi"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <h5 class="mt-4 mb-3">STATUS SOSIAL EKONOMI</h5>
              <FormRow
                v-for="row in formSosial"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <FormRow
                v-for="row in formPsikologis"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <h5 class="mt-4 mb-3">STATUS TRIASE</h5>
              <FormRow
                v-for="row in formTriase"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <table class="table responsive">
                <thead>
                  <th>SKALA TRIASE</th>
                  <th>KETERANGAN</th>
                  <th>RESPONSE TIME</th>
                </thead>
                <tbody>
                  <tr>
                    <td>SKALA 1</td>
                    <td>Resusitasi</td>
                    <td>Segera</td>
                  </tr>
                  <tr>
                    <td>SKALA 2</td>
                    <td>Emergency/gawat darurat</td>
                    <td>10 menit</td>
                  </tr>
                  <tr>
                    <td>SKALA 3</td>
                    <td>Urgent/darurat</td>
                    <td>30 menit</td>
                  </tr>
                  <tr>
                    <td>SKALA 4</td>
                    <td>Semi darurat</td>
                    <td>60 menit</td>
                  </tr>
                  <tr>
                    <td>SKALA 5</td>
                    <td>Tidak darurat</td>
                    <td>120 menit</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Simpan Data Pemeriksaan
                </button>
                <!-- <router-link class="btn btn-outline-danger btn-no-outline float-right text-uppercase" to="/ralan">Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => reset(`/ugd/detail/${$route.params.id}`)"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import {
  setPatientIntro,
  setRawatIntro,
  validateForms,
  resetForms,
} from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import {
  data,
  upperForm,
  formKeluhan,
  formVital,
  formSosial,
  formPsikologis,
  formAlergi,
  formTriase,
  today,
  time,
} from "@/data/UgdFormTriase.js";

export default {
  name: "UgdFormTriase",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    DetailRight,
    Alert,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      upperForm,
      formKeluhan,
      formVital,
      formSosial,
      formPsikologis,
      formAlergi,
      formTriase,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      formSet: {
        no_rawat: "",
        id_dokter: "",
        tgl_periksa: today,
        jam_periksa: time,
        keluhan_utama: "",
        gcs_e: "",
        gcs_v: "",
        gcs_m: "",
        pupil_luas: "",
        pupil_panjang: "",
        reflek_cahaya: "",
        suhu: "",
        tkn_darah: "",
        nadi: "",
        respirasi: "",
        spo2: "",
        reguler: "",
        pekerjaan: "",
        interaksi_sosial: [],
        status_psikologis: [],
        gangguan_perilaku: "",
        gangguan_perilaku_bahaya: "",
        status_alergi: "",
        alergi: "",
        skala_triase: "",
      },
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let body = "";
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          let item = String(self.formSet[key]);
          if (key == "status_psikologis" || key == "interaksi_sosial") {
            item = self.formSet[key].toString().replace(/,/g, "|");
            //console.log(item);
            formData.append(key, item);
          } else {
            formData.append(key, item);
          }
          body += `&${key}=${item}`;
        });
        //console.log(body);
        //console.log(formData);
        try {
          let result = await this.$store.state.HTTP_ENC.post("/triase", body);
          //console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              that.reset(`/ugd/detail/${that.$route.params.id}`);
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
    },
    reset(url, stay, noTab) {
      // if (this.validated) {
      console.log("[---noTab");
      console.log(noTab);
      console.log("]---noTab");

      resetForms(
        this.formSet,
        [
          this.upperForm,
          this.formKeluhan,
          this.formVital,
          this.formSosial,
          this.formPsikologis,
          this.formAlergi,
          this.formTriase,
        ],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = noTab ? "" : "?tab=" + fromTab;

          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = noTab ? "" : "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
      //console.log(e.target.value);
      //console.log(e);
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [
        this.upperForm,
        this.formKeluhan,
        this.formVital,
        this.formSosial,
        this.formPsikologis,
        this.formAlergi,
        this.formTriase,
      ].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              if (column.regex) {
                //console.log(column.regex);
                if (
                  String(self.formSet[column.name] || "").match(column.regex)
                ) {
                  column.error = "";
                } else {
                  column.error = column.regexError;
                  valid = false;
                }
              } else {
                column.error = "";
              }
            }
            if (column.type == "image") {
              if (self.formSet[column.name]) {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                };
                reader.readAsDataURL(self.formSet[column.name]);
              }
            } else {
              if (self.formSet[column.name]) {
                if (column.type == "checkbox_old") {
                  column.value = self.formSet[column.name];
                  //console.log(column.value);
                } else {
                  column.value = self.formSet[column.name];
                }
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.upperForm.splice(0, 1, this.upperForm[0]);
      this.formKeluhan = forms[1];
      this.formKeluhan.splice(0, 1, this.formKeluhan[0]);
      this.formVital = forms[2];
      this.formVital.splice(0, 1, this.formVital[0]);
      this.formSosial = forms[3];
      this.formSosial.splice(0, 1, this.formSosial[0]);
      this.formPsikologis = forms[4];
      this.formPsikologis.splice(0, 1, this.formPsikologis[0]);
      //console.log(this.formPsikologis);
      this.formAlergi = forms[5];
      this.formAlergi.splice(0, 1, this.formAlergi[0]);
      this.formTriase = forms[6];
      this.formTriase.splice(0, 1, this.formTriase[0]);

      //console.log(self.formSet);
      return valid;
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `dokter?per_page=9999999999`
        );
        //console.log(result);
        //console.log(result);
        if (result.status == "200") {
          this.upperForm[0].columns[2].options = result.data.data.map(
            (item) => {
              return { value: item.id, label: item.formatted_nama };
            }
          );
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    handlePopstate(event) {
      console.log("going in");
      this.reset(`/ugd/detail/${this.$route.params.id}`, false, true);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.toReset = (url, stay, noTab) => this.reset(url, stay, noTab);
    this.data.breadcrumb[1].link = `/ugd/detail/${this.$route.params.id}`;
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.$route.params.id}?darurat=1`
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log('ralan');
        //console.log(result.data);
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        //console.log('ralan');
        this.formSet["no_rawat"] = result.data.no_rawat;
        this.formSet["id_dokter"] = result.data.id_dokter;
        //console.log(this.formSet['no_rawat']);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    this.fetchDoctors();
  },
  created() {
    window.addEventListener("popstate", (event) => this.handlePopstate(event));
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("popstate", (event) =>
      this.handlePopstate(event)
    );
    next();
  },
};
</script>
